export enum OrderTypes {
    BY_SCHEDULING_HOUR = "BY_SCHEDULING_HOUR",
    BY_ARRIVAL = "BY_ARRIVAL"
}

export interface PatientQueueSettingsType {
    id?: number
    orderType?: OrderTypes
    columnType?: string
}